import { render, staticRenderFns } from "./BranchBulkAdd.vue?vue&type=template&id=508d2ca0&scoped=true"
import script from "./BranchBulkAdd.vue?vue&type=script&lang=ts"
export * from "./BranchBulkAdd.vue?vue&type=script&lang=ts"
import style0 from "./BranchBulkAdd.vue?vue&type=style&index=0&id=508d2ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d2ca0",
  null
  
)

export default component.exports